module.exports = __webpack_public_path__ + "img/图2@2x.a032b953.png";